export const resumeBuilderSelector = (state) => state.resumeBuilderReducer;
